export const addBrackets = (string: string) => {
  if (string.startsWith('(') && string.endsWith(')')) {
    return string
  }

  return `(${string})`
}
